module.exports = __webpack_public_path__ + "bc4dde5c5c550f47d677f8570941ae6d.woff2";